import { ReactNode } from "react";

export function SectionTitle({ children }: { children: ReactNode }) {
  return (
    <h2
      className={"text-sm font-semibold text-slate-500 uppercase tracking-wide"}
    >
      {children}
    </h2>
  );
}
